import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import {
  CreateParentIntegrationResponse,
  ParentIntegration,
} from '../../api/models';
import { getAll_3 as getAllParentIntegrationsFn } from '../../api/fn/parent-integrations/get-all-3';
import {
  getByOrganizationId_6 as getParentIntegrationByIdFn,
  GetByOrganizationId_6$Params,
} from '../../api/fn/parent-integrations/get-by-organization-id-6';
import {
  Create_3$Params,
  create_3 as createParentIntegrationFn,
} from '../../api/fn/parent-integrations/create-3';
import {
  update_3 as updateParentIntegrationFn,
  Update_3$Params,
} from '../../api/fn/parent-integrations/update-3';
import {
  deleteParentIntegration as deleteParentIntegrationFn,
  DeleteParentIntegration$Params,
} from '../../api/fn/parent-integrations/delete-parent-integration';

@Injectable({ providedIn: 'root' })
export class ParentIntegrationService {
  constructor(private apiService: ApiService) {}

  private _parentIntegrations$!: Observable<ParentIntegration[] | undefined>;

  getAllParentIntegrations(): Observable<ParentIntegration[] | undefined> {
    if (!this._parentIntegrations$) {
      this._parentIntegrations$ = this.apiService
        .invoke(getAllParentIntegrationsFn)
        .pipe(
          map((data) => data.parentIntegrations),
          shareReplay(1)
        );
    }
    return this._parentIntegrations$;
  }

  getParentIntegrationById(
    params: GetByOrganizationId_6$Params
  ): Observable<ParentIntegration | undefined> {
    return this.apiService
      .invoke(getParentIntegrationByIdFn, params)
      .pipe(map((data) => data.parentIntegration));
  }

  createParentIntegration(
    params: Create_3$Params
  ): Observable<CreateParentIntegrationResponse> {
    return this.apiService.invoke(createParentIntegrationFn, params);
  }

  updateParentIntegration(params: Update_3$Params): Observable<boolean> {
    return this.apiService.invoke(updateParentIntegrationFn, params).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  deleteParentIntegration(
    params: DeleteParentIntegration$Params
  ): Observable<boolean> {
    return this.apiService.invoke(deleteParentIntegrationFn, params).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  clearCache(): void {
    this._parentIntegrations$ = undefined!;
  }
}
